import React, { useEffect, useRef, useState } from 'react';
import { Wine } from 'lucide-react';
import { images } from '../data/mock';

const BarSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section
      id="bar"
      ref={sectionRef}
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background Image Full Screen */}
      <div className="absolute inset-0 z-0">
        <img
          src={images.bar[0]}
          alt="Bar Cocktails"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/50"></div>
      </div>

      {/* Content Overlay */}
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <div
            className={`transform transition-all duration-1000 ${
              isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
            }`}
          >
            <div className="inline-block bg-white text-black px-4 py-2 rounded-md text-sm font-semibold mb-6">
              🍸 Bar
            </div>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-white mb-8 leading-tight">
              L'art du cocktail
            </h2>
            <div className="space-y-6 text-lg text-white leading-relaxed max-w-3xl mx-auto">
              <p>
                Notre bar vous accueille pour prolonger la soirée dans une ambiance élégante et décontractée.
              </p>
              <p>
                Cocktails signatures, spiritueux d'exception et atmosphère raffinée jusqu'à tard dans la nuit.
              </p>
            </div>
            <div className="mt-10 inline-block">
              <div className="text-center bg-white/10 backdrop-blur-sm rounded-xl py-8 px-12 border border-white/20">
                <div className="flex items-center justify-center space-x-3 mb-3">
                  <Wine size={28} className="text-white" />
                  <h3 className="text-2xl font-semibold text-white">Service bar</h3>
                </div>
                <p className="text-gray-200 mb-4">Du lundi au dimanche</p>
                <div className="text-4xl font-bold text-white">21:30 - 00:30</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BarSection;
